import React, { FunctionComponent } from "react";
import { DesignContent } from "../Others/DesignContent";
import { PlanningContent } from "../Others/PlanningContent";
import "./SubSkillOthersNavigation.css";

interface IMenuObject {
  name: string;
  componentName: string;
  link: string;
  shown: Boolean;
}

type MenuProps = {
  menuObject: IMenuObject[];
};

export const SubSkillOthersNavigation: FunctionComponent<MenuProps> = ({
  menuObject,
}) => {
  const aaron = (compname: String) => {
    //alert(compname);
  };
  return (
    <div className="flex items-start xs:flex-col">
      {/* <ul
        className="nav nav-pills flex flex-col flex-wrap xs:flex-row xs:justify-between xs:w-full  list-none pl-0 mr-4 font-russosans"
        id="pills-tabVertical"
        role="tablist"
      >
        {menuObject.map((anObjectMapped, index) => {
          return (
            <li
              key={`${anObjectMapped.componentName}`}
              className="nav-item mb-2"
              role="presentation"
            >
              <a
                href={`#pills-${anObjectMapped.link}Vertical`}
                className="
          block
          font-medium
          text-xs
          xs:text-xxs
          leading-tight
          uppercase
          rounded
          px-6
          py-3
          focus:outline-none focus:ring-0
          bg-menublue
          text-white
        "
                id={`#pills-${anObjectMapped.link}-tabVertical`}
                data-bs-toggle="pill"
                data-bs-target={`#pills-${anObjectMapped.link}Vertical`}
                role="tab"
                aria-controls={`pills-${anObjectMapped.link}Vertical`}
                aria-selected="true"
                onClick={() => aaron(`${anObjectMapped.componentName}`)}
              >
                {anObjectMapped.name}
              </a>
            </li>
          );
        })}
      </ul> */}
      <div
        className="tab-content grow overflow-x-hidden"
        id="pills-tabContentVertical"
      >
        <div
          className="tab-pane fade show active"
          id="pills-designVertical"
          role="tabpanel"
          aria-labelledby="pills-design-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <DesignContent />
          </div>
        </div>

        <div
          className="tab-pane fade"
          id="pills-planningVertical"
          role="tabpanel"
          aria-labelledby="pills-planning-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <PlanningContent />
          </div>
        </div>
      </div>
    </div>
  );
};
